<template>
  <div class="workbench-container">
    <div class="qw-module-name">
      <div class="title-h1">待办任务</div>

      <div class="btn-list">
        <div class="filter-box" v-if="currentTab !== 1">
          <div class="filter-text">只看当前客户</div>
          <el-switch
            v-model="searchQuery.isFilter"
            active-color="#1677ff"
            :active-value="1"
            :inactive-value="0"
            @change="onChangeIsFilter"
          >
          </el-switch>
        </div>

        <div class="title-h3" v-if="needBack" @click="goPrev">
          <div class="back-text">返回</div>
          <img
            src="../../../assets/imgs/work-wx/workbench/icon_back.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <work-bench-tab
      :workbench-tab-list="workbenchTabList"
      :current-tab.sync="currentTab"
    ></work-bench-tab>
    <template v-if="loaded">
      <!-- <template>
        <header-filter
          :searchQuery.sync="searchQuery"
          @updateList="updateList"
        ></header-filter>
      </template> -->
      <template v-if="currentTab === 2">
        <div class="task-list">
          <empty-data
            v-if="signReminder.dataList && signReminder.dataList.length === 0"
            emptyText="暂无通知"
          ></empty-data>
          <template v-else>
            <div class="all-read-btn">
              <div class="notice">
                注意：<span> 未添加VE企微的客户无法发送消息</span>
              </div>
              <div
                class="task-btn"
                @click="onBatchSendSignReminder"
                v-if="signReminder.count > 0 && showBatchBtn"
              >
                立即群发
              </div>
            </div>
            <msg-sign-reminder-list-item
              v-for="(item, index) in signReminder.dataList"
              :key="index"
              :item="item"
              :unread="signReminder.count"
              @success="refreshSignReminder"
            ></msg-sign-reminder-list-item>
          </template>
        </div>
        <div class="page-split" v-if="signReminder.total > 0">
          <el-pagination
            layout="total, prev, pager, next"
            :total="signReminder.total"
            :page-size="15"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import WorkBenchTab from './components/WorkBenchTab.vue';
import MsgSignReminderListItem from './components/MsgSignReminderListItem.vue';
import workWxCommonService from '../services/work-wx-common-service';
import EmptyData from '../components/empty.vue';
import toast from '@/services/toast.js';
import signReminderService from './services/sign-reminder-service';

export default {
  data() {
    return {
      currentTab: 2,
      loaded: false,
      taskInfo: {
        taskList: [],
        count: 0,
      },
      messageInfo: {
        messageList: [],
        count: 0,
      },
      signReminder: {
        dataList: [],
        count: 0,
        total: 0,
      },
      userId: '',
      total: 0,
      currentPage: 1,
      searchQuery: {
        isFilter: 1,
        searchText: '',
      },
      isLogin: false,
      needBack: 0,
      showBatchBtn: false,
    };
  },
  components: {
    WorkBenchTab,
    MsgSignReminderListItem,
    EmptyData,
  },
  computed: {
    workbenchTabList() {
      return [
        // {
        //   label: `全部任务${
        //     this.taskInfo.count > 0 ? `（${this.taskInfo.count}）` : ''
        //   }`,
        //   value: 0,
        // },
        // {
        //   label: `预警通知${
        //     this.messageInfo.count > 0 ? `（${this.messageInfo.count}）` : ''
        //   }`,
        //   value: 1,
        // },
        {
          label: `出签提醒${
            this.signReminder.count > 0 ? `（${this.signReminder.count}）` : ''
          }`,
          value: 2,
        },
      ];
    },
  },
  watch: {
    currentTab: {
      handler(val) {
        if (this.isLogin) {
          this.init(val);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    workWxCommonService.commonLogin().then(() => {
      this.isLogin = true;
      this.init(this.currentTab, 'all');
      this.needBack = this.$route.query.needBack;
    });
  },
  methods: {
    async init(val, type) {
      this.loaded = false;
      this.currentPage = 1;
      try {
        await this.getApplicantSignReminder();
      } catch (error) {
        //
      }

      this.showBatchBtn = signReminderService.isCanShareAll();

      this.loaded = true;
    },
    async getApplicantSignReminder() {
      const params = {
        is_current: this.searchQuery.isFilter,
        page: this.currentPage,
      };
      const res = await signReminderService.getMessageSignReminderList(params);
      this.signReminder.dataList = res.page_data;
      this.signReminder.count = res.reminder_count;
      this.total = res.total_count;
    },
    refreshSignReminder() {
      this.getApplicantSignReminder();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (val === 2) {
        this.getApplicantSignReminder();
      }
    },
    updateList() {},
    goPrev() {
      this.$router.go(-1);
    },
    onChangeIsFilter() {
      this.init(this.currentTab, 'all');
    },
    // 批量
    async onBatchSendSignReminder() {
      // 获取外部联系人id列表
      const res = await signReminderService.getShareSignReminderIdList({
        is_current: this.searchQuery.isFilter,
      });

      if (!res.page_data || !res.page_data.length) {
        toast.show('暂无可发送内容');
        return;
      }

      // 调用后端接口进行存储需要群发的用户列表
      const params = res.page_data.map((item) => ({
        user_account_id: item.user_account_id,
        applicant_sign_reminder_id: item.applicant_sign_reminder_id,
      }));
      const data = await signReminderService.getMessageSignReminderBatchId({
        send_data: params,
      });

      console.error(
        '分享的链接地址',
        `/pages/sign-out-reminder/sign-out-reminder.html?batchId=${data.nonce}`,
      );
      try {
        await signReminderService._shareToExternalContact(
          res.page_data.map((item) => item.wwx_user_id),
          `/pages/sign-out-reminder/sign-out-reminder.html?batchId=${data.nonce}`,
        );
        // 0: '未发送',1: '发送失败',2: '已发送',
        await signReminderService.getMessageSignReminderStatus({
          applicant_sign_reminder_id_set: res.page_data.map(
            (item) => item.applicant_sign_reminder_id,
          ),
          status: 2,
        });
      } catch (e) {
        // await signReminderService.getMessageSignReminderStatus({ applicant_sign_reminder_id_set: res.page_data.map(item => item.applicant_sign_reminder_id), status: 1 });
      } finally {
        signReminderService.updateShareAll(); // 更新存储时间，隐藏立即群发
        this.showBatchBtn = false;

        this.getApplicantSignReminder();
      }
    },
  },
};
</script>

<style lang="less">
.task-list {
  .all-read-btn {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    align-items: center;
    .notice {
      color: #fa3137;
      font-size: 12px;
      > span {
        color: #222;
        opacity: 0.65;
      }
    }
    .el-button {
      padding: 6px 10px;
    }
  }
}
</style>
<style lang="less">
.workbench-container {
  .qw-module-name {
    display: flex;
    justify-content: space-between;
    height: 50px;
    align-items: center;
    background: #fff;
    padding: 0 15px;
    border-bottom: 1px solid #ededed;
    .title-h1 {
      font-size: 16px;
      color: #222;
      font-weight: bold;
    }
    .btn-list {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      > div {
        margin-right: 12px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .title-h3 {
      display: flex;
      justify-content: flex-end;
      height: 50px;
      align-items: center;
      .back-text {
        font-size: 14px;
        color: #666;
      }
      img {
        display: block;
        width: 16px;
        height: 16px;
        margin-left: 4px;
      }
    }
  }
  .workbench-tab {
    display: flex;
    justify-content: flex-start;
  }
  .task-list {
    padding: 1px 10px 15px;
    background: #fff;
  }
  .reminder-list {
    padding: 1px 10px 15px;
  }
  .page-split {
    display: flex;
    justify-content: flex-end;
    margin: 15px;
    padding-bottom: 15px;
  }
  .filter-box {
    display: flex;
    align-items: center;
    .filter-text {
      font-size: 12px;
      margin-right: 10px;
    }
  }
}
</style>
